/**
 * ReportSubscribers entity class
 */

import { formatDateByTimezone } from '../../../app/helpers/date'

/**
 * ReportSubscribersFactory
 * returns ReportSubscribers entity class
 *
 * @class ReportSubscribersFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportSubscribers} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportSubscribersFactory
 */
/* @ngInject */
export default function ReportSubscribersFactory (Report) {
  /* === ReportSubscribers class === */

  /**
   * ReportSubscribers model
   *
   * @class ReportSubscribers
   * @classdesc ReportSubscribers model
   * @memberof models
   * @see models
   * @extends models.Report
   * @return {models.ReportSubscribers} ReportSubscribers entity
   */
  function ReportSubscribers () {
    var obj = Report.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportSubscribers.prototype = Object.create(Report.prototype)
  ReportSubscribers.prototype.constructor = ReportSubscribers

  /* === User instance methods & fields === */

  Object.assign(ReportSubscribers.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Report#
     * @type {Object}
     */
    _fields: {
      id: Number,
      deleted: Number,
      name: String,
      status: String,
      createdTime: Number,
      from: Number,
      to: Number,
      networks: [],
      createdBy: String,
      reportType: String
    },

    /**
     * Prepare object
     *
     * @memberof models.ReportSubscribers#
     * @override
     */
    _prepare () {
      this.createdTime = formatDateByTimezone(formatDateByTimezone(this.createdTime * 1000, true).toDate(), false).toDate()
    },

    /**
     * url template
     *
     * @memberof models.ReportSubscribers#
     * @type {String}
     */
    _urlTemplate: 'api/reports/subscribers/{{::id}}'

  })

  /* === User static methods & fields === */

  // copy all static methods from ReportSubscribers class
  Object.assign(ReportSubscribers, Report)
  ReportSubscribers._name = 'ReportSubscribers'
  ReportSubscribers.init()

  // permissions
  // ReportSubscribers.access = {
  //   view: 'viewReport',
  //   delete: 'deleteReport'
  // }

  return ReportSubscribers
}
